
import * as types from '../../mutation-types'
import {setItems, ftAPI} from '../../../util/helpers'
import merge from 'deepmerge'

export default function (appConfig) {
  const state = merge({
    name: '', // App title
    mode: null, // App mode
    club: '', // Club DB name
    clubFullName: '', // Club's Full Name
    logoUrlLight: null,
    logoUrlDark: null,
    rootActivityCount: 0,
    clubCentralWebCount: 0,
    usernameInSelector: false,
    fastUserSwitch: false,
    clockIn: false,
    lockScreen: true,
    lockScreenTimeout: null,
    requirePin: false,
    pinLength: 4,
    defaultRows: 25,
    recoveryTime: 3000,
    activityId: null,
    theme: {
      enableModeSwitch: false,
      defaultMode: 'light',
      lockScreenClock: true,
      wallpaperSizing: 'contain',
      wallpaperColor: null,
      wallpaper: null,
      lightThemeLogo: null,
      lightThemePrimary: null,
      lightThemeSecondary: null,
      lightThemeTertiary: null,
      lightThemeAccent: null,
      lightThemeSecondaryAccent: null,
      lightThemeTertiaryAccent: null,
      lightThemeError: null,
      lightThemeInfo: null,
      lightThemeSuccess: null,
      lightThemeWarning: null,
      lightThemeComplimentOrange: null,
      lightThemeComplimentPurple: null,
      lightThemeComplimentYellow: null,
      lightThemeComplimentRed: null,
      lightThemeComplimentGreen: null,
      lightThemeComplimentOrangeAccent: null,
      lightThemeComplimentPurpleAccent: null,
      lightThemeComplimentYellowAccent: null,
      lightThemeComplimentRedAccent: null,
      lightThemeComplimentGreenAccent: null,
      darkThemeLogo: null,
      darkThemePrimary: null,
      darkThemeSecondary: null,
      darkThemeTertiary: null,
      darkThemeAccent: null,
      darkThemeSecondaryAccent: null,
      darkThemeTertiaryAccent: null,
      darkThemeError: null,
      darkThemeInfo: null,
      darkThemeSuccess: null,
      darkThemeWarning: null,
      darkThemeComplimentOrange: null,
      darkThemeComplimentPurple: null,
      darkThemeComplimentYellow: null,
      darkThemeComplimentRed: null,
      darkThemeComplimentGreen: null,
      darkThemeComplimentOrangeAccent: null,
      darkThemeComplimentPurpleAccent: null,
      darkThemeComplimentYellowAccent: null,
      darkThemeComplimentRedAccent: null,
      darkThemeComplimentGreenAccent: null,
      backgroundGrey: null,
      backgroundGray: null,
      backgroundBlue: null,
      backgroundBlueLight: null,
      customCss: null
    },
    terminal: {
      id: null,
      terminalGroupId: null,
      name: null,
      groupName: null
    },
    menu: [],
    acv: null
  }, appConfig)

  const mutations = {
    [types.SET_APP_CONFIG] (state, config) {
      setItems(state, config, state)
      if (ftAPI()) ftAPI().setLastAppConfig(state)
    }
  }

  return {
    state,
    mutations
  }
}
